import { api } from "../App";
import { createNotification } from "../components/Notifications/Notifications";
import {
  SET_SCHEDULE_VARIANTS_LIST,
  SET_SCHEDULE_VARIANTS_LOADING,
  SET_SCHEDULE_VARIANTS_YEAR
} from "./types";

// Единый CRUD /api/schedule_variant, режим выбирается query-параметром type (LMSTWO-701)
const TYPE = 0

export const setYear = (year) => ({ type: SET_SCHEDULE_VARIANTS_YEAR, payload: year })

export const getScheduleVariantsList = (yearId) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_SCHEDULE_VARIANTS_LOADING, payload: true });
    const year_id = yearId || getState().schedule_variants.year || null
    const params = new URLSearchParams({ type: TYPE, ...(year_id && { school_year_id: year_id }) })
    const { data } = await api.get(`/schedule_variant?${params}`);
    dispatch({ type: SET_SCHEDULE_VARIANTS_LIST, payload: data.schedule_variants });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_SCHEDULE_VARIANTS_LOADING, payload: false });
  }
}

export const createScheduleVariant = (data) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_SCHEDULE_VARIANTS_LOADING, payload: true });
    await api.post(`/schedule_variant?type=${TYPE}`, data);
    await dispatch(getScheduleVariantsList())
    createNotification('success', 'Успешно');
    success = true
  } catch (ERR) {
    createNotification('error', 'Не удалось создать запись');
  } finally {
    dispatch({ type: SET_SCHEDULE_VARIANTS_LOADING, payload: false });
    return success
  }
}

export const updateScheduleVariant = (id, data) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_SCHEDULE_VARIANTS_LOADING, payload: true });
    await api.put(`/schedule_variant/${id}?type=${TYPE}`, data);
    await dispatch(getScheduleVariantsList())
    createNotification('success', 'Успешно');
    success = true
  } catch (ERR) {
    createNotification('error', 'Не удалось обновить запись');
  } finally {
    dispatch({ type: SET_SCHEDULE_VARIANTS_LOADING, payload: false });
    return success
  }
}

export const deleteScheduleVariant = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_SCHEDULE_VARIANTS_LOADING, payload: true });
    await api.delete(`/schedule_variant/${id}?type=${TYPE}`);
    await dispatch(getScheduleVariantsList())
    createNotification('success', 'Успешно');
  } catch (ERR) {
    createNotification('error', 'Не удалось удалить запись');
  } finally {
    dispatch({ type: SET_SCHEDULE_VARIANTS_LOADING, payload: false });
  }
}
